var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavertalkThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#41B649"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.122 5H8.10588C7.62058 5 7.22681 5.3931 7.22681 5.87757V13.5696C7.22681 14.0541 7.62058 14.4472 8.10588 14.4472H14.4265L16.6827 17.1234C16.6827 17.1234 17.0935 17.712 17.4 17.6791C17.6725 17.6493 17.6565 17.3062 17.6565 17.3062V14.4472H19.1209C19.6062 14.4472 20 14.0541 20 13.5696V5.87757C20 5.3931 19.6062 5 19.1209 5H19.122ZM12.3544 10.3812C12.3544 10.6723 12.1181 10.9082 11.8276 10.9082H11.3582C11.0666 10.9082 10.8304 10.6723 10.8304 10.3812V9.06487C10.8304 8.77376 11.0666 8.5379 11.3582 8.5379H11.8276C12.1192 8.5379 12.3544 8.77376 12.3544 9.06487V10.3812ZM16.3975 10.3812C16.3975 10.6723 16.1612 10.9082 15.8696 10.9082H15.4013C15.1097 10.9082 14.8735 10.6723 14.8735 10.3812V9.06487C14.8735 8.77376 15.1097 8.5379 15.4013 8.5379H15.8696C16.1612 8.5379 16.3975 8.77376 16.3975 9.06487V10.3812Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07357 15.5288C6.58827 15.5288 6.19449 15.1357 6.19449 14.6512V9.75232H4.69496C4.31183 9.75232 4 10.0795 4 10.4833V16.8887C4 17.2924 4.31076 17.6196 4.69496 17.6196H7.26407V20.0005C7.26407 20.0005 7.29387 20.3363 7.78875 20.3108C8.03246 20.298 8.35599 19.8476 8.35599 19.8476L10.1386 17.6186H13.3984C13.7816 17.6186 14.0934 17.2913 14.0934 16.8876V15.5309L14.0913 15.5277H7.07357V15.5288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavertalkThumb);
export default __webpack_public_path__ + "static/media/navertalk_thumb.02c793d06b54ea90ed87d818c758d6e1.svg";
export { ForwardRef as ReactComponent };